import { useNavigate } from 'react-router';

import { useExperienceFlags } from '@hcs/experience-flags';
import { LEGACY_PEXP_UI_URL } from '@hcs/urls';

import { APP_CONFIG_PEXP } from '../constants/AppConfigPexp.constants';

export const useNavigateToPexp = () => {
  const navigate = useNavigate();
  const EXPERIENCE_FLAGS = useExperienceFlags();
  if (EXPERIENCE_FLAGS.PEXP_REPORT_API) {
    return () => {
      navigate(APP_CONFIG_PEXP.rootPath);
    };
  } else {
    return () => {
      // SECURITY - Known internal URL @jnettleman
      // eslint-disable-next-line security/detect-non-literal-fs-filename
      window.open(LEGACY_PEXP_UI_URL, '_self');
    };
  }
};
